// src/components/AchievementDashboard/styled.ts

import styled, { css } from "styled-components";

import { Button } from "@/components/ui/button";
import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { colourScheme } from "@/utils/styling/colours";

// Reusable gradient background function
const gradientBackground = (from: string, to: string) => css`
    background: linear-gradient(135deg, ${from}, ${to});
`;

// Container for the entire dashboard
export const Container = styled.div`
    margin: 0 auto;
    padding: 1rem;
    ${gradientBackground(
        colourScheme.darkGradientStart,
        colourScheme.darkGradientEnd
    )};
    color: ${colourScheme.white};
    min-height: 100vh;
`;

// Title of the dashboard
export const Title = styled.h1`
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 1rem;
    color: ${colourScheme.secondaryLight};
`;

// Styled Filter Button with dynamic styling based on 'active' prop
export const FilterButton = styled(Button)<{ active: boolean }>`
    font-size: 0.875rem;
    padding: 0.25rem 0.75rem;
    height: 2rem;
    ${(props) =>
        props.active
            ? css`
                  background-color: ${colourScheme.secondary};
                  color: ${colourScheme.white};
                  &:hover {
                      background-color: ${colourScheme.secondaryDark};
                  }
              `
            : css`
                  background-color: transparent;
                  color: ${colourScheme.secondaryLight};
                  border: 1px solid ${colourScheme.secondary};
                  &:hover {
                      background-color: ${colourScheme.secondary};
                      color: ${colourScheme.white};
                  }
              `}
`;

// Styled Tabs List
export const StyledTabsList = styled(TabsList)`
    display: grid;
    width: 100%;
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 1rem;
    background-color: ${colourScheme.primaryLight};
    border-radius: 0.375rem;
`;

// Styled Tabs Trigger with dynamic background color based on 'activeColor' prop
export const StyledTabsTrigger = styled(TabsTrigger)<{ activeColor: string }>`
    font-size: 0.875rem;
    color: ${colourScheme.greyLight};
    &[data-state="active"] {
        background-color: ${(props) => props.activeColor};
        color: ${colourScheme.white};
    }
`;

// Grid layout for tasks
export const TaskGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;

    @media (min-width: 768px) {
        /* md */
        grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 1024px) {
        /* lg */
        grid-template-columns: repeat(3, 1fr);
    }
`;
